import { baseUrls, apiUrls } from "../../../utils/Endpoints.config";
import { getAxiosConfig, getFomatedError, setFormatedResponse } from "../services/apiService";


/* get All Roles Service*/
const addRole = (params) => {
  const { axiosInstance, config, source } = getAxiosConfig();
  const response = axiosInstance({
    url: `${baseUrls.main}/${apiUrls.roles.addRoles}`,
    method: "POST",
    data: params,
    headers: config.headers || null,
    mode: "no-cors",
  })
    .then((res) => {
      return setFormatedResponse(res);
    })
    .catch((error) => {
      return getFomatedError(error);
    });
  return response;
};

/* get All Roles Service*/
const getAllRoles = (params) => {
  const { axiosInstance, config, source } = getAxiosConfig();
  const response = axiosInstance({
    url: `${baseUrls.main}/${apiUrls.roles.getAllRoles}`,
    method: "GET",
    headers: config.headers || null,
    mode: "no-cors",
  })
    .then((res) => {
      return setFormatedResponse(res);
    })
    .catch((error) => {
      return getFomatedError(error);
    });
  return response;
};

/* get All Roles Service*/
const getAllRolesData = (params) => {
  const { axiosInstance, config, source } = getAxiosConfig();
  const response = axiosInstance({
    url: `${baseUrls.main}/${apiUrls.roles.getAllRolesData}`,
    method: "GET",
    headers: config.headers || null,
    mode: "no-cors",
  })
    .then((res) => {
      return setFormatedResponse(res);
    })
    .catch((error) => {
      return getFomatedError(error);
    });
  return response;
};


/* get All Roles Service*/
const updateRole = (params) => {
  const { axiosInstance, config, source } = getAxiosConfig();
  const response = axiosInstance({
    url: `${baseUrls.main}/${apiUrls.roles.updateRole}`,
    method: "PUT",
    data: params,
    headers: config.headers || null,
    mode: "no-cors",
  })
    .then((res) => {
      return setFormatedResponse(res);
    })
    .catch((error) => {
      return getFomatedError(error);
    });
  return response;
};


/* Delete Role Service*/
const deleteRole = (params) => {
  const { axiosInstance, config, source } = getAxiosConfig();
  const response = axiosInstance({
    url: `${baseUrls.main}/${apiUrls.roles.deleteRole}`,
    method: "DELETE",
    data: params,
    headers: config.headers || null,
    mode: "no-cors",
  })
    .then((res) => {
      return setFormatedResponse(res);
    })
    .catch((error) => {
      return getFomatedError(error);
    });
  return response;
};

/* Assign Role Service*/
const assignRole = (params) => {
  const { axiosInstance, config, source } = getAxiosConfig();
  const response = axiosInstance({
    url: `${baseUrls.main}/${apiUrls.roles.assignRole}`,
    method: "POST",
    data: params,
    headers: config.headers || null,
    mode: "no-cors",
  })
    .then((res) => {
      return setFormatedResponse(res);
    })
    .catch((error) => {
      return getFomatedError(error);
    });
  return response;
};

/* Assign Role Service*/
const getEmployeesByRole = (params) => {
  const { axiosInstance, config, source } = getAxiosConfig();
  const response = axiosInstance({
    url: `${baseUrls.main}/${apiUrls.roles.getEmployeesByRole}`,
    method: "GET",
    params: params,
    headers: config.headers || null,
    mode: "no-cors",
  })
    .then((res) => {
      return setFormatedResponse(res);
    })
    .catch((error) => {
      return getFomatedError(error);
    });
  return response;
};




export default {
  addRole,
  getAllRoles,
  getAllRolesData,
  updateRole,
  deleteRole,
  assignRole,
  getEmployeesByRole

}